"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMAIL_REGEXP = void 0;
exports.isEmail = isEmail;
/**
 * Follow W3C implementation: https://html.spec.whatwg.org/multipage/input.html#email-state-(type=email)
 */
exports.EMAIL_REGEXP = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
function isEmail(email) {
    return new RegExp(exports.EMAIL_REGEXP, 'i').test(email);
}
